import {
	CircularProgress,
	Box,
	Grid,
	useTheme,
	useMediaQuery,
} from '@mui/material';
import LoginPageImage from '../../assets/images/background/OrangeChevron_Cropped_2000x1888.png';
import Deltorian from '../../assets/images/deltorian/Deltorian.svg';
import Header from '../Header';

const LoadingPage = () => {
	const theme = useTheme();

	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const isSmallScreen = useMediaQuery(theme.breakpoints.only('sm'));
	const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
	const is915pxOrGreater = useMediaQuery(theme.breakpoints.up('loginImage'));

	return (
		<div style={{ height: '100vh', width: '100vw' }}>
			<Header />
			{/* <Box
				sx={{
					position: 'absolute',
					bottom: 0,
					left: 0,
					height: '91.5%',
					width: is915pxOrGreater ? '915px' : '100vw',
					backgroundImage: `url(${LoginPageImage})`,
					backgroundPosition: 'left',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					display: 'flex',
					flexDirection: 'column',
				}}
			/>
			<Box
				sx={{
					position: 'relative',
					height: '91.5%',
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					zIndex: 1,
				}}
			>
				<Grid container alignItems='center' p={5} height='100%'>
					{isLargeScreen && <Grid item lg={1} />}
					{!isMobile && (
						<Grid
							item
							xs={false}
							sm={true}
							display='flex'
							justifyContent='flex-end'
							pr='5em'
						>
							<Box
								height={isLargeScreen ? '40vh' : isSmallScreen ? '100%' : '30vh'}
								width={isLargeScreen ? '40vh' : isSmallScreen ? '100%' : '30vh'}
							>
								<img src={Deltorian} alt='Deltorian' />
							</Box>
						</Grid>
					)}

					<Grid
						item
						container
						xs={12}
						sm={7}
						md={6}
						lg={5}
						px={isMobile ? 3 : 5}
						sx={{ alignItems: 'center' }}
					>
						<Box sx={{ display: 'flex', pl: '5em' }}>
							<CircularProgress size='5em' />
						</Box>
					</Grid>
				</Grid>
			</Box> */}
		</div>
	);
};

export default LoadingPage;
